import * as Sentry from "@sentry/react";
import { useEffect, useMemo, useRef, useState } from 'react'
import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue } from '../../../interface/steps.interface'
import { IStringInputSettings, StringVariants } from '../inputs.interface'
import { BACKSPACE, BANK_ACCOUNT_PREFIX } from './utils/config'
import useLocalStatus from '../../../module/hooks/useLocalStatus/useLocalStatus';

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  status: IInputStatus
  settings: IStringInputSettings
  progressTrigger?: Function
}
export const useBankAccount = ({
  value,
  name,
  handleChange,
  status,
  settings,
  progressTrigger
}: Props) => {
  const { isValidate, placeholder } = settings

  const [localValue, setLocalValue] = useState<string>(value)
  // const [localStatus, setLocalStatus] = useState<IInputStatus>(IInputStatus.none)
  const [substitution, setSubstitution] = useState<string>(value && value !== 'es' ? BANK_ACCOUNT_PREFIX : '')
  const [focused, setFocused] = useState<boolean>(false)
  const [localPlaceholder, setLocalPlaceholder] = useState<string>(
    placeholder ?? BANK_ACCOUNT_PREFIX
  )
  const [isPaste, setIsPast] = useState(false)

  const inputRef = useRef<HTMLInputElement>(null)

  const {
    localStatus,
    changeStatusHandler,
    setChangeStatusHandler
  } = useLocalStatus({
    value,
    status,
    focused,
    progressTrigger
  })

  useEffect(() => {
    if (value && value.slice(0, 2).toLocaleLowerCase() === 'es') {
      setLocalValue(value.substring(2))
    } else {
      setLocalValue(value)
    }
    // if (!value || value === 'es') setSubstitution('')
  }, [value])

  // useEffect(() => {
    
  //   if (
  //     !focused &&
  //     (status === IInputStatus.apiError
  //     || status === IInputStatus.error)
  //   ) {
  //     setLocalStatus(status)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   } else if ( status === IInputStatus.success && !focused) {
  //     setLocalStatus(IInputStatus.success)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   } else {
  //     // setLocalStatus(status)
  //   }
  // }, [status])

  useEffect(() => {
    try {
      if (focused) {
        // setLocalPlaceholder(placeholder ?? BANK_ACCOUNT_PREFIX)
      } else {
        setLocalPlaceholder('')
      }
    } catch (error) {
      console.log(error)
    }
  }, [focused])

  const localSettings = useMemo(
    () => ({
      ...settings,
      variant: StringVariants.bankAccount,
      placeholder: localPlaceholder,
    }),
    [localPlaceholder]
  )
  const disabled = useMemo(() => status === IInputStatus.disabled, [status])

  const handleLocalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('handleLocalChange')
    try {
      let newValue = event.target.value
      setChangeStatusHandler()
      // if (/^es es/.test(newValue.toLowerCase())) {
      //   newValue = newValue.replace('ES ES', 'ES ')
      // }
      if (isPaste) {
        console.log('paste')
        let noSpaces = newValue.replace(/\s/g, '');
        newValue = noSpaces.replace(/^(ES|es)/, '');
      }
      setLocalValue(newValue)
      // if (newValue.substring(0, 2).toLowerCase() === "es") {
      //   newValue = newValue.substring(2)
      // }
      // setLocalValue(
      //   newValue
      // )
      // if (newValue) {
      //   handleChange(name, 'es' + newValue, isValidate)
      // } else {
      //   handleChange(name, newValue, isValidate)
      // }
      // setLocalStatus(IInputStatus.change)
      if (progressTrigger) {
        progressTrigger()
      }
      setIsPast(false)
    } catch (error) {
      console.log(error)
    }
  }

  const handleKeydown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    try {
      if (event.key === 'Enter') {
        setFocused(false)
        const transfValue = 'es' + localValue
        handleChange(name, transfValue as string, true)
        if (progressTrigger) {
          progressTrigger()
        }
      } else if (event.key === 'Escape') {
        setFocused(false)
        setLocalValue(value)
        if (progressTrigger) {
          progressTrigger()
        }
      }
      // Не удалять префикс
      // if (
      //   event.key === BACKSPACE &&
      //   inputRef.current &&
      //   inputRef.current?.selectionStart !== null &&
      //   inputRef.current?.selectionStart <= BANK_ACCOUNT_PREFIX.length
      // ) {
      //   event.preventDefault()
      // }
    } catch (error) {
      console.log(error)
    }
  }

  const handlePaste = (event: any) => {
    setIsPast(true)
    // setLocalValue(result)
    // if (newValue.substring(0, 2).toLowerCase() === "es") {
      // setTimeout(() => {
      //   setLocalValue(newValue.substring(2))
      // }, 1)
    // } else {
      // setTimeout(() => {})
      // setLocalValue(newValue)
    // }
    // if (/^es/.test(newValue)) {
    //   newValue = newValue.slice(2)
    // }
    // setLocalValue(
    //   BANK_ACCOUNT_PREFIX + newValue.substring(BANK_ACCOUNT_PREFIX.length)
    // )
  }

  const handleFocus = (event: any) => {
    try {
      setSubstitution(BANK_ACCOUNT_PREFIX)
      // Устанавить префикс, если не установлен
      // if (localValue.length < BANK_ACCOUNT_PREFIX.length) {
      //   setLocalValue(BANK_ACCOUNT_PREFIX)
      // }
      // event.target.selectionEnd = 3
      // Установить флаг фокуса
      setFocused(true)
    } catch (error) {
      console.log(error)
    }
  }

  const handleBlur = () => {
    try {
      if (!localValue || localValue === 'es') {
        setSubstitution('')
      }
      // Удалить префикс из localValue, если кроме него ничего нет
      // if (localValue.length <= BANK_ACCOUNT_PREFIX.length) {
      //   setLocalValue('')
      // }
      // Снять флаг фокуса
      // if (value !== '' && (status === IInputStatus.apiError || status === IInputStatus.error)) {
      //   setLocalStatus(status)
      // } else if (value !== '' && status === IInputStatus.success) {
      //   setLocalStatus(IInputStatus.success)
      // } else {
      //   setLocalStatus(IInputStatus.change)
      // }
      // changeStatusHandler()
      const transfValue = 'es' + localValue
      handleChange(name, transfValue as string, true)
      if (progressTrigger) {
        progressTrigger()
      }
      setFocused(false)
    } catch (error) {
      console.log(error)
    }
  }

  return {
    localValue,
    localStatus,
    inputRef,
    disabled,
    localSettings,
    handleLocalChange,
    handleKeydown,
    handlePaste,
    handleFocus,
    handleBlur,
    substitution
  }
}
